// @file: src/actions/handle-error.js
/* eslint-disable no-alert */
/* eslint-disable no-console */

export const handleError = (error) => {
  const erro = error.response;

  console.log(erro);

  if (erro === undefined) {
    return {
      error: {
        title: "Atenção! ",
        message: "Servidor não encontrado! Entre em contato com o suporte!",
      },
    };
  }

  switch (erro.status) {
    case 404:
      if (erro.data.detail === "Scale not found") {
        return {
          error: {
            title: "Atenção! ",
            message: "Nenhuma escala de trabalho encontrada",
          },
        };
      }
      break;
    default:
      break;
  }
  return null;
};
